module.exports = __webpack_public_path__ + "img/Kingo_Kingos_salmebok.cff130cd.jpg";